import { CidadaoSelectField, CidadaoSelectFieldModel, SubmitlessForm } from 'components/form'
import { CIDADAO_PATH } from 'components/layout/SideMenu/SideMenuItems'
import { useAnalytics } from 'hooks/analytics/useAnalytics'
import { useHistory } from 'react-router'

export function AgendaCidadaoForm() {
  const history = useHistory()
  const { analytics } = useAnalytics()

  const handleSelectCidadao = (cidadao?: CidadaoSelectFieldModel) => {
    if (cidadao) {
      history.push(`${CIDADAO_PATH}/${cidadao.id}/agendamentos`)
      analytics.logEvent('visualizar_agendamentos_cidadao_AG')
    }
  }

  return (
    <SubmitlessForm<CidadaoSelectFieldModel>
      render={() => (
        <CidadaoSelectField
          name='cidadao'
          label='Agenda do cidadão'
          onChange={handleSelectCidadao}
          menuMinWidth={500}
          popperProps={{ placement: 'top-start' }}
        />
      )}
    />
  )
}
